import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Button, TextLink } from "@vds/buttons";
import { Col, Grid, Row } from "@vds/grids";
import { Input } from "@vds/core";
import { Line } from "@vds/lines";
import { DropdownSelect } from "@vds/selects";
import { TileContainer } from "@vds/tiles";
import capitalize from "lodash/capitalize";
import AsyncSelectInput from "common/components/AsyncSelectInput";
import { SpinnerComponent } from "common/components";
import ProtectionPlansMonarch from "common/components/ProtectionPlans/ProtectionPlansMonarch";
import {
  MarginSpacer2XL,
  MarginSpacerL,
  MarginSpacerM,
  MarginSpacerS,
  MarginSpacerXL,
} from "common/components/styleTag";
import useToggle from "hooks/useToggle";
import apiClient from "utils/apiClient";
import { VALIDATE_DEVICE_ID, VALIDATE_SIM_ID } from "containers/APIurls";
import {
  getCarrierDetailsByDevice,
  validateZipAndRetrieveFeatureOnBYOD,
  retrieveFeatureOnBYOD,
  setImeiWithPsimEsimCapable,
} from "pages/Mobility/ducks/MobilitySlice";
import {
  ButtonContainer,
  RowNoPad,
  AsyncWrapper,
  CustomRadioBoxGroup,
  SimRadioBoxGroup,
  TileGroup,
  OptionsTile,
  PromoBanner,
  OptionsHeader,
  OptionsDesc,
  OptionsAction,
  OptionsSelected,
  SelectedCont,
  IconCont,
  ButtonContainerMonarch,
  OptionsDesc2,
} from "./styles";
import EsimConfirmationModal from "../../eSimConfirmation";
import DeviceTileSection from "./DeviceTileSection";
import SelectedDevice from "./SelectedDevice";
import { current } from "@reduxjs/toolkit";
import { PDPAccordionSection } from "common/components/ProductDetails/components";
import { setHasBYOR, setReinitiateFlow, setRouterInfoFromByod } from "app/ducks/GlobalSlice";
import { getProductType } from "utils/productTypeUtil";
import * as SiteAnalytics from "../../../../sitecatalyst";
import {
  Text,
  TitleLockup,
  TitleLockupTitle,
  TitleLockupSubtitle,
  Notification,
  TitleLockupEyebrow,
} from "@vds/core";
import { Icon } from "@vds/icons";
import styled from "styled-components";
import GetDeviceDetailsModal from "pages/Byod/getDeviceDetails";
import { LeftImageSectionNew, DeviceInfoContainerNew, ColNoPad, RightSectionNew } from "./styles";
import ByodPackageImage from "../ByodPackageImage/ByodPackageImage";
import SelectedDeviceMonarch from "./SelectedDeviceMonarch";
import { getInitialDeviceState } from "pages/Byod/utils";
import RemoveModalByod from "pages/Byod/RemoveModalByod";


const StyledBody = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 34px;
  align-items: anchor-center;
`;
const StyledColIcon = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
`;

const TileMonarchWrapper = styled.div`
 @media (min-width: 1025px) {
  width:580px;
  }
`
const StyledCol = styled(Col)`
  // margin-left: 12px; 
`;

const InputComp = styled.span`
  [class^="VDS__MON__label-module__OyAVX VDS__MON__label-module__"] {
    display: none;
  }
   
`;

const DeviceTileMonarch = ({
  setIsAddMoreDisabled,
  sno,
  device,
  isFromLearn,
  byodList,
  showRemove = false,
  pathUrl,
  setLoading = () => { },
  handleByodRemove = () => { },
  handleDeviceUpdate = () => { },
  handleDeviceUpdateAgent = () => { },
  invalidDeviceHandler = () => { },
  handleDeviceDetailsModal = () => { },
  deviceDetailsModal,
  isMobile,
  deviceList,
  isPlansFirst,
  selectedDeviceId,
  handleDeviceId,
  currentDevice,
  showByod,
  showByodPage,
  setShowByod = () => { },
  setShowByodPage = () => { },
  setByodDeviceList = () => { },
  showLearnEditPage,
  setAddMoreDevice = () => { },
  handleMultiDeviceUpdate = () => { },
  isEditPackageFlow,
  setIsConnectedDevices = () => { },
  isConnectedDevices = false,
  setShowLegalDetails = () => { },
  isByodAgentLinkPage,
  byodAgentList,
  setShowIMEINotificationOuter,
  setShowIncompatibleNotificationOuter,
  checkProtection,
  setCheckProtection,
  isFeatureError,
  setFeatureError,
  setShowNotification = () => { }
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Initialize useNavigate

  const { t } = useTranslation(["byod", "app"]);
  const [removeDevice, setRemoveDevice] = useState(null);
  const [deviceAddMode, setDeviceAddMode] = useState(false)
  const [showButton, setShowButton] = useState(true);
  const [inputValue, setInputValue] = useState({
    imei: device?.imei,
    iccid: device?.iccid,
  });
  const actConfig = {
    label: 'Clear',
    onClick: () => {
      setInputValue({
        imei: '',
        iccid: '',
      })
    }
  }
  const pageData = useSelector((state) => state.MobilityPage);
  const globalData = useSelector((state) => state.GlobalData);
  const [showDeviceId, setShowDeviceID] = useState(true);
  const [isMakeAndModal, setIsMakeAndModal] = useState(
    false || device?.isEditable
  );
  const aemContentMonarch = t("byodMonarch.deviceTile", {
    ns: "byod",
    returnObjects: true,
  });
  const isAgentLinkPage = useSelector(
    (state) => state?.GlobalData?.fromAgentLinkDealsPage
  );
  const metaInformation = useSelector(
    (state) => state.GlobalData?.metaInformation
  );
  const sessionCartData = useSelector(
    (state) => state.GlobalData?.sessionCartData?.apiResponse?.prospectFlowData
  );
  const [showForm, setShowForm] = useState(
    (!device.completed && !device?.isDQ) || device?.isEditable
  );
  const [showProtection, setShowProtection] = useState(false);
  const [isVZNumber, setIsVZNumber] = useState(device?.isVZNumber ?? "");
  const [invalidDeviceError, setInvalidDeviceError] = useState(false);
  const [imeiCodeValid, setimeiCodeValid] = useState(true);
  const [showOptions, toggleOptions] = useToggle(
    !!device.deviceInfo && !!device.imei
  );
  const [deviceInfo, setDeviceInfo] = useState(device?.deviceInfo);
  const [showVZOptions, setShowVZOptions] = useState(false);
  const [eSimconfirmationModal, setConfirmationModal] = useState(false);
  const [selected, setSelected] = useState(device.selectedOpt);
  const [isNewSim, setIsNewSim] = useState(device.selectedOpt === "new");
  const [isOldSim, setIsOldSim] = useState(device.selectedOpt === "old");
  const [isESIM, setIsESIM] = useState(device.selectedOpt === "esim");
  const [psimCapableN, setPsimCapableN] = useState(false);
  const [isCarrier, setIsCarrier] = useState(false);
  const [isByor, setIsByor] = useState(false);
  const [isEsimIndicator, setIsEsimIndicator] = useState(false);
  const [isOldSimVerified, setIsOldSimVerified] = useState(
    device?.isOldSimVerified || false
  );
  const [showCancel, setShowCancel] = useState(false || device?.isEditable);
  const [currentDeviceSelected, setCurrentDeviceSelected] = useState(false);

  const [deviceName, setDeviceName] = useState(
    device?.deviceName || "smartphone"
  );
  const [byodDevice, setByodDevice] = useState({});
  const [simTypeSelected, setSimTypeSelected] = useState(false);
  const [carrierSelected, setCarrierSelected] = useState(false);
  const [deviceSelected, setDeviceSelected] = useState(false);
  const [showValidateDeviceId, setShowValidateDeviceId] = useState(false);
  const [imeiErrorText, setImeiErrorText] = useState("");
  const [maxLengthValue, setMaxLengthValue] = useState(0);
  const [deviceErrorText, setDeviceErrorText] = useState(
    `${t("byod.errorMessages.invalidDevice", { ns: "byod" })}`
  );
  const [showInvalidIMEI, setShowInvalidIMEI] = useState(false);
  const [showNotCompatible, setNotCompatible] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(
    device?.selectedDevice ?? null
  );
  const [carriersOpts, setCarriersOpts] = useState(
    device?.selectedDevice?.carrier ?? []
  );
  const [selectedCarrier, setSelectedCarrier] = useState(
    device?.selectedCarrier ?? null
  );
  const [validateIdLoading, setValidateIdLoading] = useState(false);
  const simOptions =
    t("byodMonarch.byod-collection.simOptions", { ns: "byod", returnObjects: true }) ??
    [];
  const portInOptions =
    t("byodMonarch.byod-collection.portInOptions", { ns: "byod", returnObjects: true }) ??
    [];
  const imeiAllowedChars = "0-9";
  const [selectedOptMakeamodel, setSelectedOptMakeamodel] = useState("");
  const resetData = () => {
    setDeviceInfoDisplayMakeModel({})
    setMakeModelImageData();
    setRemoveDevice(null);
    setSelectedDevice(null);
    setDeviceAddMode(false)
    setShowDeviceID(true);
    setDeviceInfoDisplay({});
    toggleOptions(false);
    updateDeviceList({ removeSingleDevice: true });
    setShowProtection(false);
    setCheckProtection(false)
    setShowButton(true);
    setIsNewSim(false);
    setIsOldSim(false);
    setIsESIM(false);
    setSelected(null);
    setIsVZNumber("");
    setInputValue({ imei: "", iccid: "" });
    setIsOldSimVerified(false);
    setShowCancel(false);
    setSelectedCarrier(null)
  }

  const handleByodRemoveClick = () => {
    setShowNotification(false)
    setShowIMEINotificationOuter(false)
    if (device.isByor) {
      setIsByor(false);
      dispatch(setHasBYOR(false));
      window.sessionStorage.setItem("hasBYOR", JSON.stringify(false));
      dispatch(setRouterInfoFromByod({}));
      window.sessionStorage.setItem("routerInfoFromByod", JSON.stringify({}));
    }
    if (deviceList.length == 1) {
      setRemoveDevice(device?.id)
    }
    else {
      setDeviceAddMode(false)
      handleByodRemove(device.id);
    }
  }
  const [enableChecker, setEnableChecker] = useState(false);
  const isPDPProtectionEnabled = metaInformation?.showProtectionFeaturesOnPDP &&
    !(
      deviceInfo?.category?.toLowerCase()?.includes("laptop")
    );

  const [showProtectionAcc, setShowProtectionAcc] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState(
    device?.selectedFeature ?? null
  );
  const [isProtectionLoading, setIsProtectionLoading] = useState(false);
  const [isTMPMDonInit, setTMPMDonInit] = useState(null);
  const [isFeaturesRetrieved, setRetriveFeatures] = useState(false);
  const [deviceInfoDisplay, setDeviceInfoDisplay] = useState({});
  const [deviceInfoDisplayMakeModel, setDeviceInfoDisplayMakeModel] = useState({});
  const [makeModelImageData, setMakeModelImageData] = useState()
  const isTMPMDPlaninCart =
    sessionCartData?.cart?.accountLevelFeatures &&
    Object.values(sessionCartData?.cart?.accountLevelFeatures)?.filter(a => a?.featureDesc?.includes("Total Mobile Protection Multi-Device")).length >= 1
  const isTMPMDProtectionPlanSelected = !!isPDPProtectionEnabled && isTMPMDPlaninCart;
  const isTMPMDProtectionPlanSelectedFromByod = deviceList && Object.values(deviceList)?.filter(d => d?.selectedFeature?.displayName?.includes("Total Mobile Protection Multi-Device")).length >= 1
  const offerTextPortInObj = t("app.portinOffersTextContainer.byod", { ns: "app", returnObjects: "true" });
  const showOfferText = t("app.portinOffersTextContainer.enableOfferText", { ns: "app", returnObjects: "true" });
  const [offerTextPortIn, setOfferTextPortIn] = useState("");
  const payload = {
    shoppingPath: "PROSPECT",
    approach: "",
    flow: "prospect",
  };

  const optionsList = useMemo(() => {
    const opts =
      t("byod.deviceTypeOptions", { ns: "byod", returnObjects: true }) ?? [];
    return isPlansFirst
      ? opts.filter((i) => i?.value?.toLowerCase() === "smartphone")
      : isAgentLinkPage
        ? opts.filter(
          (i) =>
            i?.value?.toLowerCase() === "laptop" ||
            i?.value?.toLowerCase() === "tablet"
        )
        : opts;
  }, [t, isPlansFirst]);

  const onDeviceTypeChange = (val, fromLearn = false) => {
    if (
      val === "tablet" ||
      val === "hotspot" ||
      val === "other" ||
      val === "laptop" ||
      val === "smartphone"
    ) {
      setDeviceName(val);
      showDeviceIdOption(val);
      setIsEsimIndicator(false);
    } else {
      showMakeAndModelOption(val);
      setDeviceName(val);
      setIsEsimIndicator(false);
    }
    if (val === "smartphone") {
      setCurrentDeviceSelected(true);
    } else {
      setCurrentDeviceSelected(false);
    }

    if (
      fromLearn === true &&
      val === "smartphone" &&
      byodDevice?.selectedCarrier
    ) {
      const selectedOption = {
        carrier: ["Verizon", "T-Mobile", "AT&T", "Other"], //byodDevice.selectedCarrier
        imageName: byodDevice.imageSet,
        make: byodDevice.make,
        modelName: byodDevice.modal,
        sku: byodDevice.deviceSku,
        technology: byodDevice.technologyType,
      };
      handleOnDeviceSelect(selectedOption, true);
    } else if (fromLearn === true && byodDevice?.imei) {
      inputClickHandler(true);
    }
  };
  const onDeviceTypeChangeLearn = (val) => {
    if (
      val === "tablet" ||
      val === "hotspot" ||
      val === "other" ||
      val === "laptop"
    ) {
      setDeviceName(val);
      showDeviceIdOption(val);
      setIsEsimIndicator(false);
    } else {
      showMakeAndModelOption(val);
      setDeviceName(val);
      setIsEsimIndicator(false);
    }
    if (val === "smartphone") {
      setCurrentDeviceSelected(true);
    } else {
      setCurrentDeviceSelected(false);
    }

    if (val === "smartphone" && byodDevice?.selectedCarrier) {
      const selectedOption = {
        carrier: ["Verizon", "T-Mobile", "AT&T", "Other"], //byodDevice.selectedCarrier
        imageName: byodDevice.imageSet,
        make: byodDevice.make,
        modelName: byodDevice.modal,
        sku: byodDevice.deviceSku,
        technology: byodDevice.technologyType,
      };
      handleOnDeviceSelect(selectedOption, true);
    } else if (byodDevice?.imei) {

      handleFormInputChange(byodDevice.imei, "imei", true);
    }
  };
  const PATTERN_IMEI = new RegExp(`^(?=[${imeiAllowedChars}]*$)(?:.{15})$`);
  const imeiWithPsimEsimCapable = pageData?.imeiWithPsimEsimCapable ?? [];

  useEffect(() => {
    setShowLegalDetails(showProtection && pageData?.zipCode || selectedFeature)
  }, [showProtection, pageData?.zipCode]);

  useEffect(() => {
    const { imei } = inputValue;
    setEnableChecker(PATTERN_IMEI.test(imei));
  }, [inputValue.imei]);

  useEffect(()=>{
    if(isVZNumber === "No"){
      SiteAnalytics.errorEncounter({ "data": aemContentMonarch?.keepNumberOfferTitle+"."+aemContentMonarch?.keepNumberOfferBody, "id": isVZNumber, "title": aemContentMonarch?.keepNumberOfferTitle+"."+aemContentMonarch?.keepNumberOfferBody, "subtitle": aemContentMonarch?.keepNumberOfferBody });
    }
  },[isVZNumber])

  useEffect(() => {
    // setDeviceInfo(device?.deviceInfo)
    if (device?.isEditable && device?.displayType?.length > 1) {
      handleByodEditClick();
    }
    if (
      (!device.completed && !device?.isDQ) ||
      device?.isEditable ||
      (device?.isDQ && !device?.completed)
    ) {
      !showForm && setShowForm(true);
    }
  }, [device]);

  useEffect(() => {
    if (selectedCarrier === "Other") {
      setIsMakeAndModal(true);
      setIsCarrier(true);
    } else {
      setIsCarrier(false);
    }
    if (deviceName) {
      setDeviceName(deviceName);
    }
  }, [deviceName, selectedCarrier]);

  useEffect(() => {
    let selectedDevice = "";
    if (
      device !== null &&
      device &&
      Object.keys(device || {}).length > 0 &&
      !device?.completed &&
      !String(device.deviceName).toLowerCase().includes("smartphone")
    ) {
      selectedDevice = pageData.deviceListBy[0].deviceName;
      setShowForm(true);
      setShowDeviceID(true);
    }
    if (!selectedDevice && showForm) {
      let isOptionIncluded = false;
      if (!device?.isDQ) {
        optionsList.forEach((item) => {
          if (pathUrl?.includes(item?.value.toLowerCase())) {
            onDeviceTypeChange(item?.value.toLowerCase());
            isOptionIncluded = true;
          } else if (pathUrl?.includes("all")) {
            onDeviceTypeChange("smartphone");
            isOptionIncluded = true;
          }
        });
      }
      if (!isOptionIncluded) {
        onDeviceTypeChange("other");
      }
    }
  }, [pathUrl]);

  useEffect(() => {
    setDeviceInfoDisplay(device?.deviceInfo);
  }, []);

  useEffect(() => {
    if (
      device?.isDQ &&
      device?.message &&
      !device?.completed &&
      !device?.selectedDevice &&
      !device?.selectedOpt
    ) {
      let deviceName = device?.message?.toLowerCase();
      if (deviceName?.includes("netbook") || deviceName?.includes("tab")) {
        deviceName = "tablet";
      } else if (deviceName?.includes("internet")) {
        deviceName = "hotspot";
      } else if (deviceName?.includes("smartphone")) {
        deviceName = "smartphone";
      } else if (deviceName?.includes("laptop")) {
        deviceName = "laptop";
      } else {
        deviceName = "other";
      }
      onDeviceTypeChange(deviceName);
    }
    if (
      deviceInfo &&
      deviceInfo?.psimCapable === "Y" &&
      deviceInfo?.esimCapable === "Y" &&
      inputValue?.imei === deviceInfo?.imei2
    ) {
      setPsimCapableN(true);
    }
    if (isEditPackageFlow) {
      setIsProtectionLoading(true);
      dispatch(retrieveFeatureOnBYOD({
        shoppingPath: "PROSPECT",
        flow: "prospect",
        zipCode: pageData?.zipCode,
        getFeatureRequest: getFeatureRequestPayload()
      }));
    }
  }, []);

  useEffect(() => {
    if (
      deviceInfo &&
      deviceInfo?.esimCapable === "Y" &&
      (deviceInfo?.psimCapable === "N" || deviceInfo?.psimCapable === undefined)
    ) {
      setSelected("esim");
      setIsEsimIndicator(false);
    }
    if (
      deviceInfo &&
      deviceInfo?.psimCapable === "Y" &&
      (deviceInfo?.esimCapable === "N" || deviceInfo?.esimCapable === undefined)
    ) {
      setSelected("new");
      setIsNewSim(true);
      setIsEsimIndicator(false);
    }
    if (
      deviceInfo &&
      deviceInfo?.psimCapable === "Y" &&
      deviceInfo?.esimCapable === "Y"
    ) {
      setIsEsimIndicator(true);
    }
    if (
      deviceInfo &&
      deviceInfo?.psimCapable === "Y" &&
      deviceInfo?.esimCapable === "Y" &&
      inputValue?.imei !== deviceInfo?.imei2
    ) {
      setPsimCapableN(false);
    }
    const deviceCat = deviceInfo?.category?.toLowerCase();
    if (deviceCat?.includes("laptop")) {
      setSelectedFeature(null);
    }
  }, [deviceInfo]);

  useEffect(() => {
    if (selected) {
      handleOnSelect();
      toggleOptions(true);
      if (selected === "new") {
        setInputValue({ ...inputValue, iccid: "" });
        setIsOldSimVerified(false);
        setIsCarrier(false);
      }

      if (
        (selected === "esim" &&
          pageData?.carrierDetailsByDevice?.esimOnlySupportedIndicator !==
          "Y") ||
        selected === "new" ||
        selected === "old"
      ) {
        setShowVZOptions(true);
      }
    }
  }, [selected]);

  const generateOfferText = (productType) => {
    let offerText = offerTextPortInObj?.[productType]
    setOfferTextPortIn(offerText);
    productType == "desk-conference-phones" ? setIsConnectedDevices(true) : setIsConnectedDevices(false);
  }

  useEffect(() => {
    if (
      pageData?.carrierDetailsByDevice &&
      device?.deviceName === "smartphone"
    ) {
      if (
        pageData?.carrierDetailsByDevice?.esimOnlySupportedIndicator === "Y" &&
        selectedDevice
      ) {
        const data = {
          selectedOpt: "esim",
          isVZNumber: "",
          selectedCarrier: null,
          deviceSku: pageData?.carrierDetailsByDevice?.deviceSku,
          simSku: pageData?.carrierDetailsByDevice?.selectedSimSku,
          category: pageData?.carrierDetailsByDevice?.category,
        };
        if (showOptions) {
          toggleOptions(false);
        }
        setSelected("");
        setIsESIM(false);
        handleDeviceUpdate(data, device.id);
        setIsCarrier(true);
        setIsMakeAndModal(false);
        setShowDeviceID(true);
        setShowVZOptions(false);
        setSelectedCarrier("");
      } else {
        if (selectedDeviceId === device?.id) {
          const data = {
            selectedOpt: null,
            isVZNumber: "",
            selectedCarrier: device?.selectedCarrier || null,
            deviceSku: pageData?.carrierDetailsByDevice?.deviceSku,
            simSku: pageData?.carrierDetailsByDevice?.selectedSimSku,
            category: pageData?.carrierDetailsByDevice?.category,
          };
          setIsEsimIndicator(false);
          setIsESIM(false);
          setIsMakeAndModal(true);
          handleDeviceUpdate(data, device.id);
          setSelected("");
        }
      }
    }
    if (pageData?.carrierDetailsByDevice) {
      let productType = getProductType(pageData?.carrierDetailsByDevice?.category ?? "");
      generateOfferText(productType ?? "");
    }
  }, [pageData?.carrierDetailsByDevice]);

  useEffect(() => {
    if (byodList && byodList.length > 0 && !showByod) {
      const byodData = byodList?.[0];
      setByodDevice(byodData);
    }
  }, [byodList]);

  useEffect(() => {
    if (byodDevice && byodDevice?.message && showLearnEditPage) {
      let deviceName = byodDevice?.message?.toLowerCase();
      if (deviceName?.includes("netbook") || deviceName?.includes("tab")) {
        deviceName = "tablet";
      } else if (deviceName?.includes("internet")) {
        deviceName = "hotspot";
      } else if (deviceName?.includes("smartphone")) {
        deviceName = "smartphone";
      } else if (deviceName?.includes("laptop")) {
        deviceName = "laptop";
      } else {
        deviceName = "other";
      }
      onDeviceTypeChangeLearn(deviceName);
      setShowByod(true);
    }
  }, [byodDevice]);

  useEffect(() => {
    if (byodAgentList && byodAgentList?.length > 0 && globalData?.isAgentlink && sessionCartData?.fromAgentLinkPage && !showByodPage) {
      byodAgentList?.forEach((item) => {
        let deviceName = item?.message?.toLowerCase();
        if (deviceName?.includes("netbook") || deviceName?.includes("tab")) {
          deviceName = "tablet";
        } else if (deviceName?.includes("internet")) {
          deviceName = "hotspot";
        } else if (deviceName?.includes("smartphone")) {
          deviceName = "smartphone";
        } else if (deviceName?.includes("laptop")) {
          deviceName = "laptop";
        } else {
          deviceName = "other";
        }
        setDeviceName(deviceName);
        showDeviceIdOption(deviceName);
        setIsEsimIndicator(false);
        setShowForm(true)
        setShowByodPage(true);
        setSelectedFeature(item?.feature);
        isVzSelected(item.isVZNumber, false);
      });

    }

  }, [byodAgentList])

  useEffect(() => {
    if (showByod === true) {
      updateDeviceList({});
    }
  }, [showByod]);
  useEffect(() => {
    if (showByodPage === true) {
      updateDeviceList(byodAgentList);
    }
  }, [showByodPage]);

  useEffect(() => {
    if (simTypeSelected === true) {
      updateDeviceList({});
      isVzSelected(byodDevice.isVZNumber, true);
      setSimTypeSelected(false);
    }
  }, [simTypeSelected]);

  useEffect(() => {
    if (deviceSelected === true) {
      handleCarrierSelect(byodDevice.selectedCarrier, true);
      setDeviceSelected(false);
    }
  }, [deviceSelected]);

  useEffect(() => {
    if (carrierSelected === true) {
      updateDeviceList({});
      isVzSelected(byodDevice.isVZNumber, true);
      setCarrierSelected(false);
    }
  }, [carrierSelected]);

  useEffect(() => {
    if (isByor) {
      updateDeviceList({});
    }
  }, [isByor])

  useEffect(() => {
    if (showValidateDeviceId === true) {
      handleOnChangeFromLearn();
      setShowValidateDeviceId(false);
    }
  }, [showValidateDeviceId]);

  useEffect(() => {
    // remove protection loading indicator
    setIsProtectionLoading(false);
    // check whether TMP-MultiDevice is available yet
    if (isTMPMDonInit === null) {
      setTMPMDonInit(isMultiDeviceProtectPresent(pageData?.PDPFeatureList));
    }
    // preselect multi-device plan, if already added
    if (sessionCartData?.cart?.packages && pageData?.PDPFeatureList?.length) {
      let multiDevInCart;
      for (const pack of Object.values(sessionCartData?.cart?.packages || {})) {
        if (pack?.features && Object.values(pack?.features ?? {})?.length > 0) {
          for (const [id, feat] of Object.entries(pack?.features || {})) {
            if (
              feat?.featureDesc?.includes(
                "Total Mobile Protection Multi-Device for Business"
              )
            ) {
              multiDevInCart = id;
              break;
            }
          }
        }
      }
      if (!!multiDevInCart) {
        const mdFeature = pageData?.PDPFeatureList?.find(
          (i) => i?.billingCode === multiDevInCart
        );
        setSelectedFeature({
          displayName: mdFeature?.name,
          featureCode: mdFeature?.billingCode,
          featureType: "SFO",
          featureLevel: "A",
          quantity: "1",
        });
      }
    }
    // check for multi-device feature in previous BYOD added
    if (deviceList?.length) {
      let multiDevInBYODList;
      for (const dev of deviceList) {
        if (dev?.selectedFeature?.displayName?.includes("Total Mobile Protection Multi-Device for Business")) {
          multiDevInBYODList = dev?.selectedFeature?.featureCode;
        }
      }
      if (!!multiDevInBYODList) {
        const mdFeature = pageData?.PDPFeatureList?.find(
          (i) => i?.billingCode === multiDevInBYODList
        );
        setSelectedFeature({
          displayName: mdFeature?.name,
          featureCode: mdFeature?.billingCode,
          featureType: "SFO",
          featureLevel: "A",
          quantity: "1",
        });
      }
    }
  }, [pageData?.PDPFeatureList]);

  const validateInput = (value, inputName) => {
    if (inputName === "imei") {
      const input = deviceList.filter(
        (d) => d.imei === value && d.id !== device.id
      );
      setImeiErrorText("");
      setShowNotification(false)
      setShowIMEINotificationOuter(false)
      setNotCompatible(false)
      setShowIncompatibleNotificationOuter(false)
      if (value.length < 1) {
        setimeiCodeValid(false);
        setInvalidDeviceError(false);
        setImeiErrorText(t("byod.errorMessages.requiredField"), {
          ns: "byod",
        });
        return;
      }
      if (!PATTERN_IMEI.test(value)) {
        setimeiCodeValid(false);
        setInvalidDeviceError(false);
        setImeiErrorText(t("byod.errorMessages.deviceidLength"), {
          ns: "byod",
        });
        return;
      }
      if (Array.isArray(input) && input.length > 0) {
        setimeiCodeValid(false);
        setInvalidDeviceError(false);
        setImeiErrorText(aemContentMonarch?.duplicateIMEI);
        return;
      }
      setimeiCodeValid(true);
      setInvalidDeviceError(false);
    }
  };

  const handleFormInputChange = (value, inputName, fromLearn = false) => {
    if (inputName === "imei") {
      let val = value.replace(/\D/g, "").slice(0,15);
      // val = value.replace(/\s/g, '')
      setInputValue((prev) => ({
        ...prev,
        [inputName]: val,
      }))

      if (val?.length >= 15) {
        setMaxLengthValue(15)
      }
      if(val.length > 0){
      validateInput(val, inputName);

      }else {
          setImeiErrorText(t("byod.errorMessages.requiredField", { ns: "byod" }));
          setimeiCodeValid(false);
          setInvalidDeviceError(false);
      }
      // validateInput(val.trim(), inputName);
      // setInputValue({ ...inputValue, [inputName]: val.trim() });
      if (fromLearn === true) {
        checkDeviceID(true);
      }
    } else {
      validateInput(value.trim(), inputName);
      setInputValue({ ...inputValue, [inputName]: value.trim() });
    }
  };


  const handleImeiKeyPress = (e) => {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault()
    }
  };

  const handleImeiPaste = (e) => {
    e.preventDefault(); 

    const pasteData = e.clipboardData.getData('text');
    const cleanedPasteData = pasteData.replace(/\D/g, '').slice(0, 15);

    const inputElement = e.target;
    const start = inputElement.selectionStart; 
    const end = inputElement.selectionEnd;
    const currentImei = inputValue.imei;

    const newValue = (
      currentImei.substring(0, start) + cleanedPasteData + currentImei.substring(end)).slice(0, 15);
    setInputValue(prev => ({
      ...prev,
      imei: newValue,
    }));
    validateInput(newValue, "imei");
  };

  const updateDeviceList = ({
    isVZNum = null,
    fromLearn = false,
    feature = null,
    removeSingleDevice = false
  }) => {
    const data = {
      selectedCarrier: selectedCarrier,
      isVZNumber: (isVZNumber ?? device?.isVZNumber) || "",
      selectedDevice: selectedDevice,
      completed: true,
      displayType: selectedCarrier ? "ByMakeAndMod" : "ByImei",
      isEditable: false,
      selectedOpt: selected,
      imei: inputValue.imei,
      iccid: inputValue.iccid,
      deviceInfo: deviceInfo,
      isOldSimVerified: isOldSimVerified,
      completed: true,
      fromLearn: fromLearn,
      packageId: fromLearn ? byodDevice?.packageId : (device?.packageId ? device?.packageId : ""),
      selectedFeature: feature,
      isByor: isByor
    };
    if (device?.packageId) {
      data.updated = true;
    }
    if (globalData?.isAgentlink && sessionCartData?.fromAgentLinkPage) {
      handleDeviceUpdateAgent(data, device.id)
    }
    else if (removeSingleDevice) {
      handleDeviceUpdate(getInitialDeviceState(), device.id);
    }
    else {
      handleDeviceUpdate(data, device.id);
    }
  };
  const onCheckAvailability = () => {
    let learnUrlLower = `${t("learnUrlLower", { ns: "app" })}`;
    let learnUrlProd = `${t("learnUrlProd", { ns: "app" })}`;
    if (window.mbtGlobal.reactUibasePath === "/mbt/prospect/") {
      window.location.href = learnUrlLower;
    } else {
      window.location.href = learnUrlProd;
    }
  }

  const checkIfRouterExist = () => {
    let routerPresent = false;
    routerPresent = deviceList?.length && deviceList?.some((device) => device?.deviceInfo?.isByor && (device?.deviceInfo?.technologyType?.includes("5G") || device?.deviceInfo?.technologyType?.includes("4G")))
    if (routerPresent) {
      return routerPresent
    }
    const pkgs = sessionCartData?.cart?.packages;
    routerPresent = Object.values(pkgs || {})?.length && Object.values(pkgs || {})?.some((pkg) => (pkg?.technologyType?.includes("5G") || pkg?.technologyType?.includes("4G")) && pkg?.byor);
    if (routerPresent) {
      return routerPresent
    } else {
      return false
    }
  }

  const checkDeviceID = async (fromLearn = false) => {
    setValidateIdLoading(true);
    try {
      let payload = {
        approach: "",
        flow: "prospect",
        deviceId: fromLearn === true ? byodDevice?.imei : inputValue.imei,
        shoppingPath: "PROSPECT",
      };
      if (isPDPProtectionEnabled && pageData?.zipCode) {
        payload.zipCode = pageData.zipCode;
        payload.getFeatureRequest = getFeatureRequestPayload({
          deviceId: fromLearn === true ? byodDevice?.imei : inputValue.imei,
        });
      }
      let url = VALIDATE_DEVICE_ID;
      if (fromLearn === true && byodDevice.iccid) {
        payload = { ...payload, simNumber: byodDevice.iccid };
        url = VALIDATE_SIM_ID;
      } else if (inputValue.iccid) {
        payload = { ...payload, simNumber: inputValue.iccid };
        url = VALIDATE_SIM_ID;
      }
      setLoading();
      const { data } = await apiClient.post(url, payload);
      const {
        serviceStatus: { message, success },
        deviceInfo: info,
      } = data;
      if (!success) {
        setInvalidDeviceError(true);
        setDeviceErrorText(
          t("byod.errorMessages.invalidDevice", { ns: "byod" })
        );
        setDeviceInfoDisplay({});
        if (showRemove) {
          setShowInvalidIMEI(true)
        }
        else {
          setShowIMEINotificationOuter(true)
        }

        //SiteAnalytics.errorEncounter({ "data": data, "id": data?.serviceStatus?.statusCode, "title": data?.serviceStatus?.statusMessage, "subtitle": "Device ID validation" });
      } else {
        if (data && Object.keys(data || {})?.length && data?.deviceInfo?.isByor) {
          if (data?.deviceInfo?.isByor && checkIfRouterExist()) {
            setImeiErrorText(aemContentMonarch?.moreRouterError);
            setValidateIdLoading(false);
            return;
          } else {
            dispatch(setHasBYOR(true));
            window.sessionStorage.setItem("hasBYOR", JSON.stringify(true));
            setIsByor(true);
            dispatch(setRouterInfoFromByod(data));
            window.sessionStorage.setItem("routerInfoFromByod", JSON.stringify(data));
          }
        }
        else if (data && Object.keys(data || {})?.length && data?.deviceInfo?.esimCapable == "Y" && data?.deviceInfo?.psimCapable == "Y") {
          let updatedArrImei = [...imeiWithPsimEsimCapable, { pSim: data?.deviceInfo?.imei1, eSim: data?.deviceInfo?.imei2 }]
          dispatch(setImeiWithPsimEsimCapable(updatedArrImei))
        }
        // if(data && Object.keys(data || {})?.length && (data?.deviceInfo?.isByor === true || data?.deviceInfo?.technologyType === "5GE"|| data?.deviceInfo?.technologyType === "4GE") && checkIfRouterExist()) {
        //   setImeiErrorText(aemContentMonarch?.moreRouterError);
        //   setValidateIdLoading(false);
        //   return;
        // }
        if (data && Object.keys(data || {})?.length && data?.deviceInfo && !(
          isPlansFirst &&
          !info?.category?.toLowerCase()?.includes("smartphone")
        ))
          setDeviceInfoDisplay(data?.deviceInfo);
        setDeviceInfoDisplayMakeModel({})
        setMakeModelImageData()
        setInvalidDeviceError(false);
        featurePreSelect();
        setShowInvalidIMEI(false)
        setShowIMEINotificationOuter(false)
        setDeviceAddMode(true)
      }
      if (
        isPlansFirst &&
        !info?.category?.toLowerCase()?.includes("smartphone")
      ) {
        // plans first is only for smartphones
        setInvalidDeviceError(true);
        setDeviceErrorText(aemContentMonarch?.incompatibleDevice);
        if (showRemove) {
          setNotCompatible(true)
        }
        else {
          setShowIncompatibleNotificationOuter(true)
        }
      } else {
        setNotCompatible(false)
        setShowIncompatibleNotificationOuter(false)
        if (fromLearn === true) {
          if (message === "SUCCESS" && !byodDevice.iccid) {
            toggleOptions();
            setShowButton(false);
            setDeviceInfo(info);
          }
          if (message === "SUCCESS" && (byodDevice.iccid || byodDevice.imei)) {
            setIsOldSimVerified(true);
            setimeiCodeValid(false);
          } else {
            setimeiCodeValid(true);
          }
        } else {
          if (message === "SUCCESS" && !inputValue.iccid) {
            toggleOptions();
            setShowButton(false);
            setDeviceInfo(info);
          }
          if (message === "SUCCESS" && (inputValue.iccid || inputValue.imei)) {
            setIsOldSimVerified(true);
            setimeiCodeValid(false);
          } else {
            setimeiCodeValid(true);
          }
        }
      }
      setValidateIdLoading(false);
      if (fromLearn === true) {
        setShowValidateDeviceId(true);
      }

      if (info) {
        let productType = getProductType(info?.category ?? "");
        generateOfferText(productType ?? "");
      }
    } catch (err) {
      console.log("IEMI_CHECK_ERR", err);
    } finally {
      setLoading();
    }
  };

  const handleCarrierSelect = (val, fromLearn = false) => {
    if (val !== "Select") {
      setDeviceAddMode(true)
      if (val === "Other") {
        const data = {
          selectedOpt: null,
          isVZNumber: "",
          imei: "",
          iccid: "",
          selectedCarrier: "",
        };
        setIsCarrier(false);
        setSelectedCarrier("");
        setSelected(null);
        setShowCancel(false);
        handleDeviceUpdate(data, device.id);
      } else {
        if (val !== "Other") {
          const data = {
            selectedOpt: null,
            isVZNumber: "",
            imei: "",
            iccid: "",
            selectedCarrier: selectedCarrier,
          };
          setIsCarrier(true);
          handleDeviceUpdate(data, device.id);
        }
        setInputValue({ imei: "", iccid: "" });
        setIsESIM(false);
        setIsNewSim(false);
        setShowDeviceID(false);
        toggleOptions(false);
        setIsVZNumber("");
      }
      setSelectedCarrier(val);
      featurePreSelect()
      if (pageData?.carrierDetailsByDevice?.serviceStatus?.success == true && val !== "Other") {
        const data = {
          deviceName: pageData?.carrierDetailsByDevice?.deviceMake + ' ' + pageData?.carrierDetailsByDevice?.deviceModel,
          carrier: val
        }
        setDeviceInfoDisplayMakeModel(data)
      }
    }
    handleDeviceUpdate({ selectedCarrier: val }, device.id);
    if (fromLearn === true) {
      setCarrierSelected(true);
    }
  };

  const handleByodEditClick = (fromEdit = "") => {
    setIsAddMoreDisabled(true)
    console.log("curr", currentDevice)
    // Set device image for make model and device details


    if (!showOptions) {
      toggleOptions();
    }
    setShowForm(true);
    setShowCancel(true);
    isPDPProtectionEnabled && setShowProtection(true);
    if (device?.imei) {
      setDeviceInfoDisplayMakeModel({})
      setMakeModelImageData()
      setIsEsimIndicator(true);
      setShowButton(false);
      setimeiCodeValid(true);
      setShowDeviceID(true);
      if (
        selectedCarrier &&
        (selectedCarrier === "Other" || device?.selectedOpt === "esim")
      ) {
        setIsMakeAndModal(true);
      } else {
        setIsMakeAndModal(false);
      }
    } else {
      const data = {
        deviceName: currentDevice?.selectedDevice?.make + ' ' + currentDevice?.selectedDevice?.modelName,
        carrier: currentDevice?.selectedCarrier
      }
      setDeviceInfoDisplayMakeModel(data)
      setMakeModelImageData({
        selectedDevice: {
          imageName: currentDevice?.selectedDevice?.imageName
        }
      })

      setIsMakeAndModal(true);
      if (device?.selectedOpt === "esim" && device?.imei) {
        setimeiCodeValid(true);
        setShowDeviceID(true);
        setShowButton(false);
      } else {
        setShowDeviceID(false);

        setIsEsimIndicator(false);
      }
    }
    if (!device?.isEditable && device?.completed && fromEdit === "fromEdit") {
      let data = {
        completed: false,
      };
      handleDeviceUpdate(data, device.id);
      let productType = getProductType(device?.deviceInfo?.category ?? "");
      generateOfferText(productType ?? "");
    }
  };

  const handleByodSave = () => {
    setIsAddMoreDisabled(false)
    dispatch(setReinitiateFlow(true))
    updateDeviceList({});
    setShowForm(false);
  };

  const handleOnDeviceSelect = (selectedOpt, fromLearn = false) => {
    setSelectedDevice(selectedOpt);
    setSelectedOptMakeamodel(selectedOpt?.modelName)
    if (!selectedOpt) {
      setCarriersOpts([]);
      setSelectedCarrier("");
      setSelected(null);
      setShowCancel(false);
      setIsNewSim(false);
      setIsOldSim(false);
      setIsESIM(false);
      setIsVZNumber("");
      setIsOldSimVerified(false);
      setInputValue({ imei: "", iccid: "" });
      setShowDeviceID(false);
      return;
    }
    handleDeviceId(device.id);
    setIsMakeAndModal(true);
    fetchSimDetails(selectedOpt);
    setMakeModelImageData({
      selectedDevice: {
        imageName: selectedOpt?.imageName
      }
    })
    setCarriersOpts(selectedOpt.carrier);
    setDeviceInfo({});
    if (isESIM || isNewSim || device.selectedCarrier === "Other") {
      const data = {
        selectedOpt: null,
        isVZNumber: "",
        imei: "",
        iccid: "",
        selectedCarrier: null,
        deviceInfo: selectedOpt,
      };
      setInputValue({ imei: "", iccid: "" });
      setIsESIM(false);
      setSelectedCarrier("");
      setSelected(null);
      setShowDeviceID(false);
      toggleOptions(false);
      handleDeviceUpdate(data, device.id);
      setIsVZNumber("");
    }
    if (fromLearn === true) {
      setDeviceSelected(true);
    }
  };

  const featurePreSelect = () => {
    if (isTMPMDProtectionPlanSelected || isTMPMDProtectionPlanSelectedFromByod // && !isFeaturesRetrieved
    ) {
      if (pageData?.zipCode) {
        setIsProtectionLoading(true);
        dispatch(retrieveFeatureOnBYOD({
          shoppingPath: "PROSPECT",
          flow: "prospect",
          zipCode: pageData?.zipCode,
          getFeatureRequest: getFeatureRequestPayload()
        }));
      }
      setRetriveFeatures(true)
      setShowProtection(true)
      setCheckProtection(true)
    }
  }

  const isVzSelected = (val, fromLearn = false) => {
    setIsVZNumber(val);
    setShowNotification(false)
    setShowIMEINotificationOuter(false)
    if (isPDPProtectionEnabled && !isConnectedDevices) {
      if (pageData?.zipCode && !isFeaturesRetrieved) {
        setIsProtectionLoading(true);
        dispatch(retrieveFeatureOnBYOD({
          shoppingPath: "PROSPECT",
          flow: "prospect",
          zipCode: pageData?.zipCode,
          getFeatureRequest: getFeatureRequestPayload()
        }));
        if (!fromLearn) {
          setShowProtection(true);
          setCheckProtection(true)
        }
        // updateDeviceList({ isVZNum: val, fromLearn: fromLearn });
        if (fromLearn === true) {
          setShowForm(false);
          setByodDeviceList([]);
          setAddMoreDevice(true);
        }
      } else if (!pageData?.zipCode) {
        if (!fromLearn) {
          setShowProtection(true);
          setCheckProtection(true)
        }
        // updateDeviceList({ isVZNum: val, fromLearn: fromLearn });
        if (fromLearn === true) {
          setShowForm(false);
          setByodDeviceList([]);
          setAddMoreDevice(true);
        }
      } else {
        setShowForm(false);
        onFeatureSelect(selectedFeature, fromLearn);
        updateDeviceList({ isVZNum: val, fromLearn: fromLearn, feature: selectedFeature });
        if (fromLearn === true) {
          setByodDeviceList([]);
          setAddMoreDevice(true);
        }
        const element = document.getElementById(`byod-tile-${sno}`);
        if (element)
          element?.scrollIntoView({ behavior: "smooth", block: "start" });

      }

    } else {
      setShowForm(false);
      updateDeviceList({ isVZNum: val, fromLearn: fromLearn });
      if (fromLearn === true) {
        setByodDeviceList([]);
        setAddMoreDevice(true);
      }
      const element = document.getElementById(`byod-tile-${sno}`);
      if (element)
        element?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const status = () => {
    let editable = false;
    let cancelable = false;

    editable =
      (deviceInfo &&
        !showForm &&
        (device.selectedOpt === "new" ||
          device.selectedOpt === "old" ||
          device.selectedOpt === "esim")) ||
      (device.isDQ && !inputValue.imei && !showForm) ||
      ((device.isDQ || device.selectedDevice) && !showForm);

    cancelable =
      (showForm && showCancel) || (device.isDQ && showForm && showCancel);
    return {
      editable,
      cancelable,
    };
  };

  const fetchSimDetails = ({ sku, modelName }) => {
    const reqPayload = {
      sku,
      ...payload,
      deviceModel: modelName,
    };
    if (isPDPProtectionEnabled && pageData?.zipCode) {
      reqPayload.zipCode = pageData.zipCode;
      reqPayload.getFeatureRequest = getFeatureRequestPayload({ deviceSku: sku });
    }
    dispatch(getCarrierDetailsByDevice(reqPayload));
  };

  const resetFields = (val = null) => {
    if (showOptions) {
      toggleOptions();
    }
    const data = {
      isVZNumber: "",
      selectedOpt: null,
      imei: "",
      iccid: "",
      deviceInfo: null,
      isOldSimVerified: false,
      completed: false,
      isEditable: false,
      selectedCarrier: null,
      selectedDevice: null,
      displayType: "",
    };
    if (device?.packageId) {
      data.updated = true;
    }
    if (val) {
      data.deviceName = val;
      data.selectedDevice = null;
      data.selectedOpt = null;
    }
    setInputValue({ imei: data?.imei, iccid: data?.iccid });
    handleDeviceUpdate(data, device.id);
    setShowCancel(false);
  };

  const showDeviceIdOption = (val = null) => {
    setSelectedDevice(null)
    setShowDeviceID(true);
    setSelectedCarrier(null);
    setIsMakeAndModal(false);
    setIsEsimIndicator(true);
    resetFields(val);
  };

  const showMakeAndModelOption = (val = null) => {
    setShowDeviceID(false);
    setSelectedCarrier(null);
    setIsMakeAndModal(true);
    resetFields(val);
  };

  const inputClickHandler = () => {
    setShowButton(true);
    setIsNewSim(false);
    setIsOldSim(false);
    setIsESIM(false);
    setSelected(null);
    setIsVZNumber("");
    setInputValue({ ...inputValue, iccid: "" });
    setIsOldSimVerified(false);
    setShowForm(true);
    setShowCancel(false);
    if (showOptions) {
      toggleOptions();
    }
  };


  const handleOnSelect = () => {
    setIsNewSim(selected === "new");
    setIsOldSim(selected === "old");
    setIsESIM(selected === "esim");
  };

  const handleActiveEsim = () => {
    setInputValue({ imei: deviceInfo.imei2, iccid: "" });
    setConfirmationModal(false);
    setSelected("old");
    setIsEsimIndicator(false);
    setPsimCapableN(true);
  };

  const handleOnChange = (value) => {
    setShowNotification(false)
    setShowIMEINotificationOuter(false)
    if (
      inputValue.imei === deviceInfo.imei1 &&
      deviceInfo.euiccCapable === false &&
      value === "old"
    ) {
      setConfirmationModal(true);
      setSelected(null);
    } else {
      setSelected(value);
    }
  };

  const handleOnChangeFromLearn = () => {
    setShowNotification(false);
    setShowIMEINotificationOuter(false);
    if (
      byodDevice?.imei === deviceInfo?.imei1 &&
      deviceInfo?.euiccCapable === false &&
      byodDevice?.selectedOpt === "old"
    ) {
      setConfirmationModal(true);
      setSelected(null);
    } else {
      setSelected(byodDevice?.selectedOpt);
    }
    setSimTypeSelected(true);
  };

  const handleActivePsim = () => {
    setSelected("new");
    setConfirmationModal(false);
  };

  const getFeatureRequestPayload = (currentDevice) => {
    const pkgs = sessionCartData?.cart?.packages;
    const returnList = [];
    // get list of devices from session cart packages
    for (const pkg of Object.values(pkgs || {})) {
      if (!pkg?.dummy && !pkg?.byod) {
        returnList.push({
          deviceSku: pkg.deviceSku,
          simSku: pkg.simSku,
          deviceCategory: pkg?.deviceType === "FOURGROUTER" ? "4g internet" : pkg.deviceCategory
        });
      }
    }
    // get list of previously added BYOD devices
    for (const dev of deviceList) {
      if (dev?.displayType && dev?.id !== device?.id) {
        returnList.push({
          deviceSku: dev.deviceInfo?.deviceSkuId ?? dev?.deviceSku,
          simSku: dev.deviceInfo?.simSku ?? dev?.simSku,
          deviceCategory:
            dev.deviceInfo?.originalCategory ?? dev?.category
        });
      }
    }
    // append current PDP device
    if (currentDevice) {
      returnList.push(currentDevice);
    } else {
      const currDevice = deviceInfo?.deviceSkuId
        ? {
          deviceSku: deviceInfo?.deviceSkuId,
          simSku: deviceInfo?.simSku,
          deviceCategory: deviceInfo?.category,
        }
        : device?.deviceSku
          ? {
            deviceSku: device?.deviceSku,
            simSku: device?.simSku,
            deviceCategory: device?.category,
          }
          : inputValue?.imei
            ? {
              deviceId: inputValue.imei,
            }
            : null;
      if (currDevice) {
        returnList.push(currDevice);
      }
    }
    return returnList;
  };

  const onZipCodeSubmit = (zip) => {
    setIsProtectionLoading(true);
    const payload = {
      shoppingPath: "PROSPECT",
      flow: "prospect",
      zipCode: zip || pageData?.zipCode,
      getFeatureRequest: getFeatureRequestPayload(),
    };
    dispatch(validateZipAndRetrieveFeatureOnBYOD(payload));
  };

  const onFeatureSelect = (feat, fromLearn = false) => {
    setCheckProtection(false)
    setFeatureError(false)
    setSelectedFeature(feat);
    //fix for protection selection closing form
    if (!(status().cancelable)) {
      setShowForm(false);
    }
    if (feat?.displayName?.includes("Total Mobile Protection Multi-Device")) {
      const updatedDevList = [];
      for (const dev of deviceList) {
        if (
          dev?.deviceInfo?.category?.toLowerCase()?.includes("laptop")
        ) {
          // don't add protection to laptop/connected device
          const data = { ...dev };
          updatedDevList.push(data);
        } else if (dev?.completed === true) {
          // update existing devices with TMP-MD
          const data = { ...dev, selectedFeature: feat };
          updatedDevList.push(data);
        } else {
          // add current device
          const data = {
            selectedCarrier: selectedCarrier,
            isVZNumber: (isVZNumber ?? device?.isVZNumber) || "",
            selectedDevice: selectedDevice,
            completed: true,
            displayType: selectedCarrier ? "ByMakeAndMod" : "ByImei",
            isEditable: false,
            id: device?.id,
            hasDeviceID: true,
            selectedOpt: selected,
            imei: inputValue.imei,
            iccid: inputValue.iccid,
            deviceInfo: deviceInfo,
            isOldSimVerified: isOldSimVerified,
            completed: true,
            fromLearn: fromLearn,
            selectedFeature: feat,
          };
          if (device?.packageId) {
            data.updated = true;
          }
          updatedDevList.push(data);
        }
      }
      handleMultiDeviceUpdate(updatedDevList);
    } else {
      updateDeviceList({ feature: feat, fromLearn: fromLearn });
    }
    if (fromLearn === true) {
      setByodDeviceList([]);
      setAddMoreDevice(true);
    }
    const element = document.getElementById(`byod-tile-${sno}`);
    if (element)
      element?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const isMultiDeviceProtectPresent = (featureList) => {
    if (featureList?.length) {
      for (const feat of pageData?.PDPFeatureList) {
        if (feat?.name?.includes("Total Mobile Protection Multi-Device")) {
          return true;
        }
      }
    }
    return false;
  };

  const editRemoveSaveComp = () => {
    return (<ButtonContainerMonarch isMobile={isMobile}>
      {status().editable && (
        <span>
          <Button
            onClick={() => handleByodEditClick("fromEdit")}
            size="small"
            type="standAlone"
            use="secondary"
            data-track={`Device | ${sno} | Edit`}
          >
            {t("byod.byod-collection.edit", { ns: "byod" })}
          </Button>
        </span>
      )}
      {status().cancelable && (
        <span>
          <Button
            onClick={handleByodSave}
            size="small"
            type="standAlone"
            use="secondary"
            data-track={`Device | ${sno} | Save`}
          >
            {t("byod.byod-collection.save", { ns: "byod" })}
          </Button>
        </span>
      )}
      {(showRemove || deviceAddMode || deviceList.some((device) => device.completed === true)) && (
        <span>
          <Button
            size="small"
            type="standAlone"
            onClick={handleByodRemoveClick}
            use="secondary"
            data-track={`Device | ${sno} | Remove`}
          >
            {t("byod.byod-collection.remove", { ns: "byod" })}
          </Button>
        </span>
      )}
    </ButtonContainerMonarch>)
  }
  const [deviceInformation, setDeviceInformation] = useState({});
  useEffect(() => {
    console.log(deviceInfoDisplay)
    const device = {
      brand: deviceInfoDisplay?.deviceName ?? deviceInfoDisplay?.name,
      imageSet: deviceInfoDisplay?.imageSet,
      imei: deviceInfoDisplay?.imei
    };
    setDeviceInformation(device);
  }, [deviceInfoDisplay])

  const getPromoText = (category) => {
    //for make or modal selected device - category set as smartphones
    if (selectedDevice) {
      category = "pda/smartphones";
    }
    let cat = category?.toLowerCase();
    if (cat?.includes("smartphone")) {
      cat = "pda/smartphones";
    } else if (cat?.includes("tablet")) {
      cat = "tablets";
    } else if (cat?.includes("laptop")) {
      cat = "laptops";
    }
    switch (cat) {
      case "pda/smartphones":
        return aemContentMonarch?.portInPromoSmartPhone;
      case "tablets":
        return aemContentMonarch?.portInPromoTablet;
      case "laptops":
        return aemContentMonarch?.portInPromoLaptop;
      // default:
      //   return aemContentMonarch?.portInPromoSmartPhone;
    }
  };

  return (
    <TileContainer
      aspectRatio="none"
      backgroundColor="#F3EDE0"
      height="100%"
      padding={isMobile ? "16px" : "32px"}
    >
      <div style={{ width: "100%" }} id={`byod-tile-${sno}`}>
        {validateIdLoading && <SpinnerComponent />}

        <Notification
          kind="error"
          title={aemContentMonarch?.invalidIMEITitle}
          bodyText={aemContentMonarch?.invalidIMEISubTitle}
          fullBleed={false}
          showCloseButton={false}
          buttons={
            showRemove
              ? []
              : [
                {
                  kind: "secondary",
                  children: "Shop new devices",
                  dataTrack: "Device IMEI | IMEI not compatible message | Shop new devices button",
                  onClick: () => navigate("/shop/products/devices/smartphones"), // Navigate to the desired route
                },
              ]
          }
          opened={showInvalidIMEI}
        />
        {showInvalidIMEI && <MarginSpacerXL />}
        <Notification
          kind="error"
          title={aemContentMonarch?.notMobilePhoneTitle}
          bodyText={aemContentMonarch?.notMobilePhoneSubTitle}
          fullBleed={false}
          showCloseButton={false}
          opened={showNotCompatible}
        />
        {showNotCompatible && <MarginSpacerXL />}
        {showForm && (Object.keys(deviceInfoDisplay || {})?.length || Object.keys(deviceInfoDisplayMakeModel || {})?.length) ?
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <LeftImageSectionNew>
              <div>
                {inputValue?.imei ? <ByodPackageImage
                  device={deviceInformation}
                  description={{}}
                  deviceList={{}}
                  width={72}
                  height={72}
                /> :
                  <ByodPackageImage
                    device={{}}
                    description={{}}
                    deviceList={makeModelImageData}
                  />
                }
              </div>
              <DeviceInfoContainerNew >
                <div>
                  <TitleLockup>
                    <TitleLockupEyebrow size="bodyLarge" >{t("byod.deviceDescription.deviceSno", {
                      ns: "byod",
                      sno: sno,
                    })}</TitleLockupEyebrow>
                    {inputValue?.imei !== '' ? <TitleLockupTitle bold size="titleXSmall" >
                      {deviceInfoDisplay?.deviceName
                        ? deviceInfoDisplay?.deviceName
                        : deviceInfoDisplay?.productName}
                    </TitleLockupTitle> : <TitleLockupTitle bold size="titleXSmall" >
                      {deviceInfoDisplayMakeModel?.deviceName}
                    </TitleLockupTitle>}
                    {inputValue?.imei !== '' ? <TitleLockupSubtitle size="bodyLarge" > {aemContentMonarch?.imeiLabelTop}
                      {inputValue?.imei}
                    </TitleLockupSubtitle> : <TitleLockupSubtitle size="bodyLarge" > Carrier:
                      {deviceInfoDisplayMakeModel?.carrier}
                    </TitleLockupSubtitle>}
                  </TitleLockup>
                </div>
                <StyledColIcon>
                  {inputValue?.imei && <Icon name="alternate-checkmark" size="medium" color="#004B1C" />}

                  {deviceInfo && device?.isByor && <Text kind="body" color="#004B1C" size="medium">{aemContentMonarch?.byorContent?.compatible}</Text>}
                  {deviceInfo && !device?.isByor && deviceInfo?.psimCapable == "Y" && deviceInfo?.esimCapable == "Y" && <Text kind="body" color="#004B1C" size="medium">{(isOldSim || isESIM) ? aemContentMonarch?.embeddedSimActive : isNewSim ? aemContentMonarch?.physicalSimActive : aemContentMonarch?.compatible}</Text>}
                  {deviceInfo && !device?.isByor && !(deviceInfo?.psimCapable !== "Y" && deviceInfo?.esimCapable !== "Y") && <Text kind="body" color="#004B1C" size="medium">{
                    ((deviceInfo?.psimCapable === "N" || deviceInfo?.psimCapable === undefined) && deviceInfo?.esimCapable === "Y") ? aemContentMonarch?.embeddedSimActive :
                      (deviceInfo?.psimCapable === "Y" && deviceInfo?.esimCapable === "N") ? aemContentMonarch?.physicalSimActive : ""
                  }</Text>}
                </StyledColIcon>
              </DeviceInfoContainerNew>
            </LeftImageSectionNew>
            <RightSectionNew >
              {editRemoveSaveComp()}
            </RightSectionNew>
          </div> : showForm ?
            <Grid
              colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
              colGutter={false}
            >
              <RowNoPad>
                <TitleLockup>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <TitleLockupTitle size="titleMedium" bold={true} >
                      {device.isDQ ? capitalize(deviceName) : isMakeAndModal ? aemContentMonarch?.title2 : aemContentMonarch?.title}
                    </TitleLockupTitle>
                    {editRemoveSaveComp()}
                  </div>
                  <TitleLockupSubtitle size="large" bold={false}>
                    {isMakeAndModal ? <span dangerouslySetInnerHTML={{ __html: aemContentMonarch?.subtitle1Makeamodel }}></span> :
                      <span dangerouslySetInnerHTML={{ __html: aemContentMonarch?.subTitle1 }}></span>}
                  </TitleLockupSubtitle>
                  <MarginSpacerL />
                  <TitleLockupSubtitle size="large" bold={false}>
                    {(isMakeAndModal || device?.selectedOpt === "esim") ? <span>{aemContentMonarch?.subTitle2Makeamodel}</span> : <span>{aemContentMonarch?.subTitle2}<TextLink style={{ fontWeight: '600' }}>{aemContentMonarch?.subTitle2Number}</TextLink>{aemContentMonarch?.subTitle2NumberOr}</span>}
                    {!(isMakeAndModal || device?.selectedOpt === "esim") && <TextLink onClick={handleDeviceDetailsModal} data-Track="Add a device | Device IMEI | Get directions here">{aemContentMonarch?.subTitle2TextLink}</TextLink>}
                  </TitleLockupSubtitle>
                </TitleLockup>
              </RowNoPad>
            </Grid> : <></>
        }
        {showForm && !isByodAgentLinkPage &&
          (!showDeviceId ||
            device?.selectedOpt === "esim" ||
            device?.selectedCarrier === "Other" ||
            device?.selectedOpt === "new") &&
          device?.deviceName === "smartphone" &&
          (!showDeviceId || device?.selectedOpt === "esim")
          && (!(status().cancelable)) && !Object.keys(deviceInfoDisplayMakeModel || {})?.length && (
            <Grid
              colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
              gutterWidth="12px"
            >
              <RowNoPad>
                <Col colSizes={{ mobile: 4, tablet: 6, desktop: 5 }}>
                  <MarginSpacerL />
                  <AsyncWrapper>
                    <AsyncSelectInput
                      defaultValue={device?.selectedDevice?.modelName ?? ""}
                      helperText={t("byod.skipImei.select1PlaceHolder", {
                        ns: "byod",
                      })}
                      label={t("byod.skipImei.select1", { ns: "byod" })}
                      onSelect={handleOnDeviceSelect}
                      flow="byod"
                    />
                  </AsyncWrapper>
                </Col>
                <Col colSizes={{ mobile: 4, tablet: 6, desktop: 5 }}>
                  {showForm &&
                    isMakeAndModal &&
                    (device?.selectedOpt !== "esim" || selectedCarrier) &&
                    selectedDevice && (
                      <>
                        <MarginSpacerL />
                        <DropdownSelect
                          error={false}
                          disabled={false}
                          readOnly={false}
                          inlineLabel={false}
                          value={selectedCarrier}
                          helperTextPlacement="bottom"
                          onChange={(e) => handleCarrierSelect(e.target.value)}
                          label={t("byod.skipImei.select2", { ns: "byod" })}
                          width="90%"
                          data-track={`Add a smartphone | Carrier | ${selectedCarrier}`}
                        >
                          <option>
                            {t("byod.skipImei.select2DefaultOption", {
                              ns: "byod",
                            })}
                          </option>
                          {carriersOpts?.map((carrier) => (
                            <option key={carrier} value={carrier}>
                              {carrier}
                            </option>
                          ))}
                        </DropdownSelect>
                      </>
                    )}
                  {/* {selectedCarrier === "Other" && (
                    <>
                      <MarginSpacerL />
                      <Text kind="body" size="small">
                        {t("byod.info3", { ns: "byod" })}
                      </Text>
                    </>
                  )} */}
                </Col>
              </RowNoPad>
              <RowNoPad>
                <Col colSizes={{ mobile: 4, tablet: 7, desktop: 7 }}>
                  {device?.selectedOpt === "esim" || selectedCarrier === "Other" && (
                    <>
                      <MarginSpacerL />
                      <Text kind="body" size="small">
                        {aemContentMonarch.info3}
                      </Text>
                      <MarginSpacerL />
                      <Text kind="body">
                        <span>{aemContentMonarch?.subTitle2}<TextLink style={{ fontWeight: '600' }}>{aemContentMonarch?.subTitle2Number}</TextLink>{aemContentMonarch?.subTitle2NumberOr}</span>
                        <TextLink onClick={handleDeviceDetailsModal} data-Track="Add a device | Device IMEI | Get directions here">{aemContentMonarch?.subTitle2TextLink}</TextLink>
                      </Text>
                    </>
                  )}
                </Col>
              </RowNoPad>
              <RowNoPad>
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                  {device?.selectedOpt !== "esim" &&
                    (!isMakeAndModal || !selectedDevice) && (
                      <>
                        <MarginSpacerS />
                        <TextLink
                          onClick={() => showDeviceIdOption()}
                          size="small"
                          type="standAlone"
                          data-track="Add a device | Device IMEI | Enter device IMEI instead"
                        >
                          {aemContentMonarch?.insteadAddIMEI}
                        </TextLink>
                      </>
                    )}
                </Col>
              </RowNoPad>
              {/* <RowNoPad>
                <Col colSizes={{ mobile: 4, tablet: 8, desktop: 8 }}>
                  {showForm &&
                    isMakeAndModal &&
                    (device?.selectedOpt !== "esim" || selectedCarrier) &&
                    selectedDevice && (
                      <>
                        <MarginSpacerL />
                        <DropdownSelect
                          error={false}
                          disabled={false}
                          readOnly={false}
                          inlineLabel={false}
                          value={selectedCarrier}
                          helperTextPlacement="bottom"
                          onChange={(e) => handleCarrierSelect(e.target.value)}
                          data-track={`Add a smartphone | Carrier | {${selectedCarrier}`}
                          label={t("byod.skipImei.select2", { ns: "byod" })}
                        >
                          <option>
                            {t("byod.skipImei.select2DefaultOption", {
                              ns: "byod",
                            })}
                          </option>
                          {carriersOpts?.map((carrier) => (
                            <option key={carrier} value={carrier}>
                              {carrier}
                            </option>
                          ))}
                        </DropdownSelect>
                      </>
                    )}
                  {selectedCarrier === "Other" && (
                    <>
                      <MarginSpacerL />
                      <Text kind="body" size="small">
                        {t("byod.info3", { ns: "byod" })}
                      </Text>
                    </>
                  )}
                </Col>
              </RowNoPad> */}
            </Grid>
          )}
        {showForm && (!(status().cancelable)) &&
          ((showDeviceId && !Object.keys(deviceInfoDisplay || {})?.length) || selectedCarrier === "Other" ||
            (!isByodAgentLinkPage && device?.selectedOpt === "esim")) && (
            <Grid
              colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
              colGutter={false}
              gutterWidth="10px"
            >
              <RowNoPad>
                <Col colSizes={{ mobile: 4, tablet: 8, desktop: 8 }}>
                  <MarginSpacerXL />
                  <InputComp>
                    <Input
                      required={false}
                      label={aemContentMonarch?.imeiLabel}
                      // inlineActionButton={invalidDeviceError ? actConfig : {}}
                      maxLength={maxLengthValue}
                      name="deviceID"
                      width={"100%"}
                      value={inputValue.imei}
                      type="text"
                      inputMode="numeric"
                      onKeyPress={handleImeiKeyPress}
                      onPaste={handleImeiPaste}
                      onBlur={(e) => {
                        const targetValue = e?.target?.value;
                        if (!targetValue) {
                          setImeiErrorText(
                            t("byod.errorMessages.requiredField"),
                            {
                              ns: "byod",
                            }
                          );
                        }
                      }}
                      success={inputValue.imei.length === 15 && !imeiCodeValid && !imeiErrorText}
                      error={invalidDeviceError || (!!imeiErrorText && inputValue.imei.length === 15) || (!!imeiErrorText && inputValue.imei.length < 15)}
                      errorText={invalidDeviceError ?
                        <div dangerouslySetInnerHTML={{
                          __html: deviceErrorText
                        }}></div>
                        :
                        imeiErrorText}
                      onChange={(e) =>
                        handleFormInputChange(e?.target?.value, "imei")
                      }
                      onClick={(e) => inputClickHandler()}
                      helperText={`15-digit number ${inputValue.imei.length}/15`}
                      helperTextPlacement="bottom"
                      containerBackground="filled"
                    />
                  </InputComp>
                </Col>

                <StyledCol colSizes={{ mobile: 4, tablet: 3, desktop: 3 }}>
                  {!isMobile ? <MarginSpacer2XL /> : <MarginSpacerM />}
                  <div style={{ marginLeft: `${isMobile ? '0px' : '12px'}`, paddingBottom: "5px" }}>
                    <Button
                      size="medium"
                      disabled={
                        false
                      }
                      use="primary"
                      data-track="Add a device | Device IMEI | Submit"
                      onClick={(e) => {
                        // if((inputValue?.imei != "" && !imeiCodeValid) ||
                        // !enableChecker ||
                        // invalidDeviceError){
                        const data = {
                          deviceName: deviceName,
                        };
                        if (!(invalidDeviceError || !!imeiErrorText || (!!imeiErrorText && inputValue.imei.length < 15))) {
                          handleDeviceUpdate(data, device.id);
                          checkDeviceID();
                        }
                        else { return; }

                      }
                      }
                    >
                      {aemContentMonarch?.submit}
                    </Button>
                  </div>
                </StyledCol>
              </RowNoPad>
              <RowNoPad>
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                  {inputValue.imei.length > 0 && !showButton && (
                    <>
                      <MarginSpacerS />
                      <Text kind="body" size="small" color="#000000">
                        {t("byod.deviceinfo-modal.deviceInfo", {
                          ns: "byod",
                        })}
                      </Text>
                      <MarginSpacerS />
                    </>
                  )}
                </Col>
              </RowNoPad>
              <RowNoPad>
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                  {device?.selectedOpt !== "esim" && (
                    <>
                      {showButton &&
                        deviceName === "smartphone" &&
                        selectedCarrier !== "Other" && (
                          <>
                            <MarginSpacerXL />
                            <TextLink
                              onClick={() => showMakeAndModelOption()}
                              size="small"
                              type="standAlone"
                              data-track="Add a device | Device IMEI | I don't know my smartphone IMEI"
                            >
                              {aemContentMonarch?.noDeviceId}
                            </TextLink>
                          </>
                        )}
                    </>
                  )}
                </Col>
              </RowNoPad>
              <RowNoPad>
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                  {
                    (!!Object.keys(selectedDevice || {})?.length) && (
                      <>
                        <MarginSpacerS />
                        <TextLink
                          onClick={() => showDeviceIdOption()}
                          size="small"
                          type="standAlone"
                          data-track="Add a smartphone | Enter device IMEI instead"
                        >
                          {aemContentMonarch?.insteadAddIMEI}
                        </TextLink>
                      </>
                    )}
                </Col>
              </RowNoPad>
            </Grid>)}

        <TileMonarchWrapper >
          {showForm &&
            (showDeviceId ||
              (!isByodAgentLinkPage && device?.selectedOpt === "esim")) && (
              <Grid
                colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
                colGutter={false}
                gutterWidth="10px"
              >
                <RowNoPad>
                  <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                    {showForm && showOptions && (
                      <div className="choice-wrapper">
                        {/* This is esim and psim capable scenario */}
                        {device &&
                          deviceInfo &&
                          deviceInfo?.psimCapable === "Y" &&
                          deviceInfo?.esimCapable === "Y" &&
                          isEsimIndicator &&
                          !psimCapableN && (
                            <>
                              {!isMobile && <MarginSpacerL />}
                              <Line type="secondary" />
                              <MarginSpacerL />
                              <TitleLockup >
                                <TitleLockupTitle size="titleSmall" bold={true}>
                                  {aemContentMonarch?.simTitle}
                                </TitleLockupTitle>
                                <TitleLockupSubtitle size="bodyLarge">
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: aemContentMonarch?.simSubTitle
                                    }}
                                  />
                                </TitleLockupSubtitle>
                              </TitleLockup>
                              <MarginSpacerL />
                              <TileGroup>
                                <TileContainer
                                  aspectRatio="none"
                                  backgroundColor="#f6f6f6"
                                  height="284px"
                                  width="282px"
                                  padding="0px"
                                >
                                  <OptionsTile selected={selected === "old"}>
                                    <OptionsHeader>
                                      <Text kind="title" size="small">{simOptions[2]?.heading}</Text>
                                      <div style={{ minWidth: "20px" }}>
                                        {selected === "old" && <IconCont style={{ width: "20px", height: "20px", borderRadius: "50%", background: "#000000", marginTop: "5px" }}>
                                          <Icon name="checkmark" size="small" color="#FFFFFF" />
                                        </IconCont>}
                                      </div>
                                    </OptionsHeader>
                                    <OptionsDesc2>
                                      <Text kind="body" size="large" color="#716F6D">{simOptions[2]?.description}</Text>
                                    </OptionsDesc2>
                                    {
                                      selected === "old" ?
                                        <OptionsSelected>
                                          <SelectedCont>
                                            <Text kind="body" size="large" bold={true} color="#E10014">Selected</Text>
                                          </SelectedCont>
                                        </OptionsSelected> :
                                        <OptionsAction>
                                          <Button use="secondary" size="large" width="100%" data-track={`Device | ${sno} | I want an embedded SIM`} onClick={() => handleOnChange("old")}>Select</Button>
                                        </OptionsAction>
                                    }
                                  </OptionsTile>
                                </TileContainer>
                                <TileContainer
                                  aspectRatio="none"
                                  backgroundColor="#f6f6f6"
                                  height="284px"
                                  width="282px"
                                  padding="0px"
                                >
                                  <OptionsTile selected={selected === "new"}>
                                    <OptionsHeader>
                                      <Text kind="title" size="small">{simOptions[0]?.heading}</Text>
                                      <div style={{ minWidth: "20px" }}>
                                        {selected === "new" && <IconCont style={{ width: "20px", height: "20px", borderRadius: "50%", background: "#000000", marginTop: "5px" }}>
                                          <Icon name="checkmark" size="small" color="#FFFFFF" />
                                        </IconCont>}
                                      </div>
                                    </OptionsHeader>
                                    <OptionsDesc2>
                                      <Text kind="body" size="large" color="#716F6D">{simOptions[0]?.description}</Text>
                                    </OptionsDesc2>
                                    {
                                      selected === "new" ?
                                        <OptionsSelected>
                                          <SelectedCont>
                                            <Text kind="body" size="large" bold={true} color="#E10014">Selected</Text>
                                          </SelectedCont>
                                        </OptionsSelected> :
                                        <OptionsAction>
                                          <Button use="secondary" size="large" width="100%" data-track={`Device | ${sno} | I want a physical SIM`} onClick={() => handleOnChange("new")}>Select</Button>
                                        </OptionsAction>
                                    }
                                  </OptionsTile>
                                </TileContainer>
                              </TileGroup>
                            </>
                          )}
                      </div>
                    )}
                  </Col>
                </RowNoPad>
              </Grid>
            )}
          {showForm && device?.isByor && (
            <>
              <MarginSpacerL />
              <TitleLockup >
                <TitleLockupTitle size="titleSmall" bold={true}>
                  {aemContentMonarch?.byorContent?.title}
                </TitleLockupTitle>
                <MarginSpacerS />
                <Text kind="body" size="large">
                  {aemContentMonarch?.byorContent?.subTitle}
                </Text>
              </TitleLockup>

              <MarginSpacerL />

              <div>
                <Button
                  disabled={false}
                  onClick={onCheckAvailability}
                  size="large"
                  surface="light"
                  use="primary"
                  width={`${isMobile ? '100%' : 'auto'}`}
                  data-track="Body | Button | Check availability"
                >
                  {aemContentMonarch?.byorContent?.checkAvailability}
                </Button>
              </div>
            </>
          )}
          {showForm && !device?.isByor &&
            !eSimconfirmationModal &&
            ((selectedCarrier && isMakeAndModal && !isCarrier) || (globalData?.isAgentlink && sessionCartData?.fromAgentLinkPage) ||
              (showOptions &&
                (isNewSim || isESIM || isOldSim) &&
                (selected || !isCarrier || isEsimIndicator))) && (

              <>
                <MarginSpacerL />
                <TitleLockup >
                  <TitleLockupTitle size="titleSmall" bold={true}>
                    {aemContentMonarch?.portInTitle}
                  </TitleLockupTitle>

                </TitleLockup>
                <MarginSpacerL />
                <TileGroup>
                  <TileContainer
                    aspectRatio="none"
                    backgroundColor="#f6f6f6"
                    height={getPromoText(deviceInfoDisplay?.category) ? "320px" : "264px"}
                    width="282px"
                    padding="0px"
                  >
                    <OptionsTile selected={isVZNumber === "Yes"}>
                      {(deviceInfoDisplay?.category || selectedDevice) &&
                        !!getPromoText(deviceInfoDisplay?.category) &&
                        <div style={{ minHeight: "56px" }}>
                          <PromoBanner>
                            <Icon name="tag" size="small" color="#FFFFFF" />
                            <Text size="small" bold={true} color="#FFFFFF">{getPromoText(deviceInfoDisplay?.category)}</Text>
                          </PromoBanner>
                        </div>}
                      <OptionsHeader>
                        <Text kind="title" size="small">{portInOptions[0]?.heading}</Text>
                        <div style={{ minWidth: "20px" }}>
                          {isVZNumber === "Yes" && <IconCont style={{ width: "20px", height: "20px", borderRadius: "50%", background: "#000000", marginTop: "5px" }}>
                            <Icon name="checkmark" size="small" color="#FFFFFF" />
                          </IconCont>}
                        </div>
                      </OptionsHeader>
                      <OptionsDesc>
                        <Text kind="body" size="large" color="#716F6D">{portInOptions[0]?.description}</Text>
                      </OptionsDesc>
                      {
                        isVZNumber === "Yes" ?
                          <OptionsSelected>
                            <SelectedCont>
                              <Text kind="body" size="large" bold={true} color="#E10014">Selected</Text>
                            </SelectedCont>
                          </OptionsSelected> :
                          <OptionsAction>
                            <Button use="secondary" size="large" width="100%" data-track={`Device | ${sno} | Transfer my current phone number`} onClick={() => isVzSelected("Yes", device?.fromLearn)}>Select</Button>
                          </OptionsAction>
                      }
                    </OptionsTile>
                  </TileContainer>
                  <TileContainer
                    aspectRatio="none"
                    backgroundColor="#f6f6f6"
                    height="264px"
                    width="282px"
                    padding="0px"
                  >

                    <OptionsTile selected={isVZNumber === "No"}>
                      <OptionsHeader>
                        <Text kind="title" size="small">{portInOptions[1]?.heading}</Text>
                        <div style={{ minWidth: "20px" }}>
                          {isVZNumber === "No" && <IconCont style={{ width: "20px", height: "20px", borderRadius: "50%", background: "#000000", marginTop: "5px" }}>
                            <Icon name="checkmark" size="small" color="#FFFFFF" />
                          </IconCont>}
                        </div>
                      </OptionsHeader>
                      <OptionsDesc>
                        <Text kind="body" size="large" color="#716F6D">{portInOptions[1]?.description}</Text>
                      </OptionsDesc>
                      {
                        isVZNumber === "No" ?
                          <OptionsSelected>
                            <SelectedCont>
                              <Text kind="body" size="large" bold={true} color="#E10014">Selected</Text>
                            </SelectedCont>
                          </OptionsSelected> :
                          <OptionsAction>
                            <Button use="secondary" size="large" width="100%" data-track={`Device | ${sno} | I want a new phone number`} onClick={() => isVzSelected("No", device?.fromLearn)}>Select</Button>
                          </OptionsAction>
                      }
                    </OptionsTile>
                  </TileContainer>
                </TileGroup>
                <MarginSpacerL />
                <TileMonarchWrapper>
                  <Notification kind="success" data-color="green" title={aemContentMonarch?.transferNumberOfferTitle} bodyText={aemContentMonarch?.transferNumberOfferBody} opened={(deviceInfoDisplay?.category || selectedDevice) &&
                        !!getPromoText(deviceInfoDisplay?.category) && isVZNumber === "Yes" } showCloseButton={false} />
                  <Notification kind="error" data-color="red" title={aemContentMonarch?.keepNumberOfferTitle} bodyText={aemContentMonarch?.keepNumberOfferBody} opened={(deviceInfoDisplay?.category || selectedDevice) &&
                        !!getPromoText(deviceInfoDisplay?.category) && isVZNumber === "No"} showCloseButton={false} />
                </TileMonarchWrapper>
              </>
            )}
          {!!showForm && !device?.isByor && !!showProtection && !isConnectedDevices && !isTMPMDProtectionPlanSelected && !isTMPMDProtectionPlanSelectedFromByod && (
            <DeviceTileSection
              title={t("byod.byodProtectionContent.title", { ns: "byod" })}
            >
              <ProtectionPlansMonarch
                selectedFeature={device?.selectedFeature}
                isLoading={isProtectionLoading}
                isError={isFeatureError && selectedFeature === null}
                onZipCodeSubmit={onZipCodeSubmit}
                onPlanClick={(e) => onFeatureSelect(e, device?.fromLearn)}
                bgColor={"transparent"}
                isMultiDevAlready={isTMPMDonInit}
                currentLineId={deviceInfo?.deviceSkuId || device?.deviceSku}
                isTMPMDProtectionPlanSelected={isTMPMDProtectionPlanSelected}
                isTMPMDProtectionPlanSelectedFromByod={isTMPMDProtectionPlanSelectedFromByod}
                fromBYODMonarch={true}
                sno={sno}
              />
            </DeviceTileSection>
          )}
          {!!showForm && !device?.isByor && !!showProtection && isVZNumber && !isConnectedDevices && (isTMPMDProtectionPlanSelected || isTMPMDProtectionPlanSelectedFromByod) &&
            <>
              <MarginSpacerL />
              <PDPAccordionSection
                opened={!!showProtectionAcc}
                setOpened={setShowProtectionAcc}
                titleText={t("device-pdp.pdpProtectionContent.title", { ns: "pdp" })}
                subTitleText={device?.selectedFeature?.featureCode
                  ? device?.selectedFeature?.displayName
                  : t("device-pdp.pdpProtectionContent.subtitle", { ns: "pdp" })}
                dataTrack="ShowProtection"
              >
                <ProtectionPlansMonarch
                  selectedFeature={device?.selectedFeature}
                  isLoading={isProtectionLoading}
                  isError={isFeatureError && selectedFeature === null}
                  onZipCodeSubmit={onZipCodeSubmit}
                  onPlanClick={(e) => onFeatureSelect(e, device?.fromLearn)}
                  isMultiDevAlready={isTMPMDonInit}
                  currentLineId={deviceInfo?.deviceSkuId || device?.deviceSku}
                  isTMPMDProtectionPlanSelected={isTMPMDProtectionPlanSelected}
                  isTMPMDProtectionPlanSelectedFromByod={isTMPMDProtectionPlanSelectedFromByod}
                  fromBYODMonarch={true}
                  bgColor={"transparent"}
                  sno={sno}
                />
              </PDPAccordionSection>
            </>
          }
        </TileMonarchWrapper>
        {!showForm && (
          <SelectedDeviceMonarch
            key={device?.id}
            deviceInfo={deviceInfo}
            deviceName={deviceName}
            sno={sno}
            currentDevice={currentDevice}
            selectedDevice={device?.selectedDevice ?? selectedDevice}
            selectedCarrier={selectedCarrier}
            device={device}
            inputValue={inputValue}
            isOldSim={isOldSimVerified}
            isESIM={isESIM}
            isNewSim={isNewSim}
            isVZNumber={isVZNumber}
            selectedFeature={device?.selectedFeature ?? selectedFeature}
            comp1={editRemoveSaveComp}
            onCheckAvailability={onCheckAvailability}
            isMobile={isMobile}
          />
        )}
        {eSimconfirmationModal && (
          <EsimConfirmationModal
            showModal={true}
            close={setConfirmationModal}
            handleActiveEsim={handleActiveEsim}
            handleActivePsim={handleActivePsim}
          />
        )}
      </div>
      {deviceDetailsModal && (
        <div style={{ height: "763px" }}>
          {deviceList &&
            deviceList.map((device) => (
              <GetDeviceDetailsModal
                device={device}
                pathUrl={pathUrl}
                showModal={true}
                close={handleDeviceDetailsModal}
              />
            ))}
        </div>
      )}
      {removeDevice && (
        <RemoveModalByod
          deviceId={removeDevice}
          showModal={true}
          close={setRemoveDevice}
          removeByodDevice={resetData}
        />
      )}
    </TileContainer>

  );
};

export default DeviceTileMonarch;
